import React, { useContext, useState } from 'react'
import { FiChevronDown, FiChevronRight, FiChevronUp, FiSearch } from 'react-icons/fi'
import { PiShareNetworkLight } from 'react-icons/pi'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { IoMdClose } from 'react-icons/io'
import AccordionTwo from '../Components/accordion/AccordionTwo'
import Statement from '../Components/statement/Statement';
import CustomSelect from '../Components/select/CustomSelect';
import DownloadModal from '../Components/statement/DownloadModal';
import Loader from '../Components/loader/Loader';
import UserDetails from '../context/UserDetails'
import axios from 'axios'
import { Navigate } from 'react-router-dom'

const ITEMS_PER_PAGE = 15

function paginate(data, itemsPerPage, currentPage) {
    // const totalPages = Math.ceil(data.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    // const endIndex = Math.min(startIndex + itemsPerPage, data.length);
    const currentPageItems = data.slice(0, startIndex);
    return currentPageItems;
}



const options = [
    {
        label: 'Recent Transactions',
        value: 'recent_transaction'
    },
    {
        label: 'Current Month',
        value: 'current_month'
    },
    {
        label: 'Last Month',
        value: 'last_month'
    },
    {
        label: 'Last 3 Month',
        value: 'last_3_months'
    },
    {
        label: 'Last 6 Month',
        value: 'last_6_months'
    },
    {
        label: 'Current Financial Year',
        value: 'current_financial_year'
    },
    {
        label: 'Last Finacial Year',
        value: 'last_financial_year'
    },
    {
        label: 'Select Date Range',
        value: 'custom'
    }
]

const Account = () => {
    const [moreDetails, setMoreDetails] = useState(false)
    const [more, setMore] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [search, setSearch] = useState('')
    const [selected, setSelected] = useState(options[0])

    const [showPopup, setShowPopup] = useState(false)
    const [loader, setLoader] = useState(false)

    const [transactions, setTransactions] = useState([])
    const [currentPage, setCurrentPage] = useState(1)

    const { user, token } = useContext(UserDetails)

    const formated = new Intl.NumberFormat('en-IN').format(user?.balance)

    const handleDetailsToggle = () => {
        setMoreDetails(prev => !prev)
    }
    const handleToggleMore = () => {
        if (currentPage < Math.ceil(transactions.length / ITEMS_PER_PAGE)) {
            setCurrentPage(prev => prev + 1)
        } else {
            setCurrentPage(1)
        }
    }
    const handleToggle = () => {
        setIsSearch(prev => !prev)
    }
    const handleChange = value => {
        setSelected(value)
        if (value.value !== 'recent_transaction') {
            setShowPopup(true)
        }
    }

    const handleClose = () => {
        setShowPopup(false)
    }

    const handleAccordionOpen = async () => {
        if (transactions.length === 0) {
            try {
                setLoader(true)
                const response = await axios.get('api/users/transactions/', {
                    headers: {
                        "Content-Type": 'application/json',
                        "Authorization": 'Token ' + token
                    }
                })
                if (response.status === 200) {
                    const data = response.data
                    setTransactions(data)
                }
            } catch (e) {
                console.log(e)
                setLoader(false)
            } finally {
                setLoader(false)
            }
        }
    }

    if (!token) {
        return <Navigate to='/' />
    }

    return (
        <React.Fragment>
            <div className='bottom-content'>
                <div className='box'>
                    <div className='p-3'>
                        <p>Savings Account</p>
                        <p className='text-gray-500' style={{ wordSpacing: '2px' }}>
                            {user?.account_number?.slice(0,4)}  {user?.account_number?.slice(4,8)}  {user?.account_number?.slice(8,12)}  {user?.account_number?.slice(12)}
                        </p>
                    </div>
                    <hr />
                    <div className='p-3'>
                        <p><small className='block'>Available Balance</small></p>
                        <div className='flex gap-2 items-baseline text-light-blue'>
                            <p><strong>&#8377;</strong></p>
                            <div className='flex items-baseline'>
                                <h1>{formated.slice(0, formated.length - 2)}</h1>
                                <p>{formated.slice(formated.length - 2)}</p>
                            </div>
                        </div>
                        <p><small className='block'>(Account Balance + Overdraft - Hold)</small></p>
                        {
                            moreDetails ?
                                <React.Fragment>
                                    <hr className='my-3' />
                                    <div className='my-5'>
                                        <div className='flex mb-3 mb-3 gap-2'>
                                            <div className='w-2/5'>
                                                <p>Account Holder</p>
                                            </div>
                                            <div className='grow'>
                                                <p className='capitalize'>{user?.first_name} {user?.last_name}</p>
                                            </div>
                                        </div>
                                        <div className='flex mb-3 mb-3 gap-2'>
                                            <div className='w-2/5'>
                                                <p>Nominee</p>
                                            </div>
                                            <div className='grow'>
                                                <p className='capitalize'>-</p>
                                            </div>
                                        </div>
                                        <div className='flex mb-3 mb-3 gap-2'>
                                            <div className='w-2/5'>
                                                <p>Branch</p>
                                            </div>
                                            <div className='grow'>
                                                <p className='capitalize'>{user?.bank_branch?.branch_name}</p>
                                            </div>
                                        </div>
                                        <div className='flex mb-3 mb-3 gap-2'>
                                            <div className='w-2/5'>
                                                <p>IFSC</p>
                                            </div>
                                            <div className='grow'>
                                                <p className='uppercase'>{user?.bank_branch?.ifsc_code}</p>
                                            </div>
                                        </div>
                                        <div className='flex mb-3 mb-3 gap-2'>
                                            <div className='w-2/5'>
                                                <p>MMID</p>
                                            </div>
                                            <div className='grow'>
                                                <p className='link'>Generate <AiOutlineInfoCircle className='inline' size={20} /> </p>
                                            </div>
                                        </div>
                                        <div className='flex mb-3 gap-2'>
                                            <div className='w-2/5'>
                                                <p>Virtual Payment Address</p>
                                            </div>
                                            <div className='grow'>
                                                <p className='link'>Register</p>
                                            </div>
                                        </div>
                                        <div className='flex mb-3  mb-3 gap-2'>
                                            <div className='w-2/5'>
                                                <p>Account Balance</p>
                                            </div>
                                            <div className='grow'>
                                                <p>&#8377; {formated.slice(0, formated.length - 2)}<small>{formated.slice(formated.length - 2)}</small></p>
                                            </div>
                                        </div>
                                        <div className='flex mb-3  mb-3 gap-2'>
                                            <div className='w-2/5'>
                                                <p>Uncleared Funds</p>
                                            </div>
                                            <div className='grow'>
                                                <p>&#8377; 0<small>.00</small></p>
                                            </div>
                                        </div>
                                        <div className='flex mb-3  mb-3 gap-2'>
                                            <div className='w-2/5'>
                                                <p>Amount on Hold</p>
                                            </div>
                                            <div className='grow'>
                                                <p>&#8377; 0<small>.00</small></p>
                                            </div>
                                        </div>
                                        <div className='mb-3'>
                                            <p>Linked Cards</p>
                                            <div className='flex mb-3 mb-3 gap-2'>
                                                <div className='w-2/5'>
                                                    <p>Card</p>
                                                </div>
                                                <div className='grow'>
                                                    <p>Primary Card</p>
                                                    <p>4763********4352</p>
                                                    <p className='link'>View Card Details</p>
                                                </div>
                                            </div>
                                            <div className='flex mb-3 mb-3 gap-2'>
                                                <div className='w-2/5'>
                                                    <p>Spending Limit</p>
                                                </div>
                                                <div className='grow'>
                                                    <p>&#8377; 40000<small>.00</small></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                                :
                                null

                        }
                    </div>
                    <hr />
                    <div>
                        <button className='block w-full text-center py-2 link' onClick={handleDetailsToggle}>
                            {moreDetails ? 'Hide' : 'Show'} Account Details
                            {moreDetails ? <FiChevronUp className='inline icon' /> : <FiChevronDown className='inline icon' />}
                        </button>
                    </div>
                    <hr />
                    <div>
                        <button className='block w-full text-center py-4 link'> <PiShareNetworkLight className='inline icon' /> Share Account Details</button>
                    </div>
                </div>
                <div className='box my-3'>
                    <AccordionTwo customClass="py-3 px-3" title={'Statement'} onAccordionOpen={handleAccordionOpen}>
                        <div className='flex gap-4 my-2 items-end'>
                            <div className="grow">
                                {isSearch ?
                                    <div>
                                        <div>
                                            <small className='link'>Search</small>
                                        </div>
                                        <input className='search-input' placeholder='Search' />
                                    </div>
                                    : <CustomSelect options={options} onChange={handleChange} defaultValue={selected} />}
                            </div>
                            <div className='w-14 text-end'>
                                <button className='link' onClick={handleToggle}>
                                    {isSearch ? <IoMdClose className='inline icon' color='#000' /> : <FiSearch className='inline icon' />}
                                </button>
                            </div>
                        </div>
                        {
                            transactions.length > 0 && paginate(transactions, ITEMS_PER_PAGE, currentPage).map(transaction => <Statement {...transaction} />)
                        }

                        <hr style={{ margin: '0 -0.75rem' }} />
                        <div>
                            <button className='block w-full text-center py-2 link' onClick={handleToggleMore}>Show {currentPage === Math.ceil(transactions.length / ITEMS_PER_PAGE) ? 'Less' : 'More'} {currentPage === Math.ceil(transactions.length / ITEMS_PER_PAGE) ? <FiChevronUp className='inline icon' /> : <FiChevronDown className='inline icon' />} </button>
                        </div>
                    </AccordionTwo>
                </div>
                <div className='box my-3'>
                    <button className='p-3 w-full flex justify-between text-start items-center'>
                        <h4>Protect Against Insufficient Funds</h4>
                        <FiChevronRight className='inline link icon' />
                    </button>
                    <hr />
                    <div className='p-3'>
                        <p>
                            Connect your other Current/Savings accounts/Deposits to this account so that you will always be protected against insufficient funds or bounced cheques.
                        </p>
                    </div>
                </div>
                <h4 className='my-3 px-3'>Actions</h4>
                <div className='box my-3'>
                    <div className='px-3'>
                        <button className='py-3 w-full flex justify-between link items-center'>
                            <p>Open Fixed Deposit</p>
                            <FiChevronRight className='inline icon' />
                        </button>
                        <hr />
                        <button className='py-3 w-full flex justify-between link items-center'>
                            <p>Open Recurring Deposit</p>
                            <FiChevronRight className='inline icon' />
                        </button>
                        <hr />
                        <button className='py-3 w-full flex justify-between link items-center'>
                            <p>Open Tax Saver Deposit</p>
                            <FiChevronRight className='inline icon' />
                        </button>
                        <hr />
                        <button className='py-3 w-full flex justify-between link items-center'>
                            <p>Manage Alerts</p>
                            <FiChevronRight className='inline icon' />
                        </button>
                        <hr />
                        <button className='py-3 w-full flex justify-between link items-center'>
                            <p>Request Cheque Book</p>
                            <FiChevronRight className='inline icon' />
                        </button>
                    </div>
                    <button className='p-3 w-full more-action-btn flex items-center justify-between'>
                        More Actions
                        <FiChevronDown className='inline icon' />
                    </button>
                </div>
            </div>
            <DownloadModal show={showPopup} selectedOption={selected} onClose={handleClose} />
            <Loader show={loader} message={'Loading...'} overlay={true} />
        </React.Fragment>
    )
}

export default Account